export const featureId = 'diagnosticImagingCenter';